import PropTypes from 'prop-types'
import React from 'react'
import { cn } from 'ethcss'
import ReactPlayer from 'react-player'
import DropMenu from 'blocks.simple/dropMenu/dropMenu'
import RangeVolume from 'blocks.simple/range/_volume/range_volume'
import Draggable from 'blocks.simple/draggable/draggable'
import Icon from 'blocks.simple/icon/icon'
import TableEditorPreview from 'blocks.app/tableEditor/_preview/tableEditor_preview'
import PreviewWebApp from 'blocks.app/preview/__webApp/preview__webApp'
import { PreviewMediaMessage } from 'blocks.app/preview/__media/preview__media'
import EditorItemLocalMethods from 'blocks.app/editor/__item/editor__item.local.methods'
import { ReactSVG } from 'react-svg'
import { TEXT_DISPLAY_AS } from 'core/models/Files'
import styles from './editor__item.jcss'
import grid from 'blocks.simple/grid/grid.jcss'
import item from 'blocks.simple/item/item.jcss'
import helpers from 'core/helpers'
import filesHelpers from 'core/helpers/_files'
import translate from 'core/translate'
import './editor__item_style.css'
import { editor } from '../editor.local.methods'

const getWebAppSizes = (s_, p_) => {
    const position = s_.position
    const resolutionWidth = p_.resolutionWidth
    const resolutionHeight = p_.resolutionHeight
    const area = p_.area

    if (!position || !resolutionWidth || !resolutionHeight || !area) return null

    return {
        width: position.width * resolutionWidth * area.width,
        height: position.height * resolutionHeight * area.height,
    }
}

const getScrollInfo = (item) => {
    if (!item || !item.data) return 'yes'

    return !item.data.scroll || item.data.scroll === 'on' ? 'yes' : 'no'
}

function isSvgUrl(urlString) {
    try {
        const url = new URL(urlString)
        return url.pathname.toLowerCase().endsWith('.svg')
    } catch (e) {
        return false
    }
}

const getItemImage = (src) => {
    const isSvg = isSvgUrl(src)

    if (!isSvg) {
        return (
            <div className={styles.imgWrapper}>
                <img className={grid.full} src={src} alt="" />
                <div className={styles.opacityLayer} />
            </div>
        )
    }

    return (
        <div className={styles.imgWrapper}>
            <ReactSVG
                className={styles.svgWrapper}
                src={src}
                beforeInjection={(svg) => {
                    svg.classList.add(grid.full)
                    svg.setAttribute('preserveAspectRatio', 'none')
                }}
            />
            <div className={styles.opacityLayer} />
        </div>
    )
}

class Preview extends EditorItemLocalMethods {
    render() {
        const p_ = this.props

        if (p_.pictogramName) {
            return (
                <div
                    className={styles.imgWrapper}
                    ref={(canvasWrapperRef) => {
                        this.canvasWrapperRef = canvasWrapperRef
                    }}
                >
                    {p_.pictogramName === 'rectangle' || p_.pictogramName === 'circle' ? (
                        <div
                            ref={(containerRef) => {
                                this.containerRef = containerRef
                            }}
                        />
                    ) : (
                        <ReactSVG
                            className={styles.svgContainer}
                            src={p_.src}
                            beforeInjection={(svg) => {
                                svg.setAttribute('preserveAspectRatio', p_.fillMode === 'stretch' ? 'none' : 'xMidYMid')
                                svg.classList.add(styles.svg)
                                svg.style.fill = p_.style.fill
                                svg.style.stroke = p_.style.stroke
                                svg.style.strokeWidth = p_.style.strokeWidth

                                if (p_.style.rx) {
                                    svg.querySelector('rect').setAttributeNS(null, 'rx', p_.style.rx)
                                }

                                const s = new XMLSerializer()
                                const str = s.serializeToString(svg)

                                if (
                                    p_.body !== str // && p_.isActive
                                ) {
                                    editor.setSvgBody(p_.selectedArea, p_.contentIndex, str)
                                }
                            }}
                        />
                    )}
                    <div className={styles.opacityLayer} />
                </div>
            )
        }
        if (!p_.fillMode) {
            return getItemImage(p_.src)
        }
        if (p_.fillMode === 'stretch') {
            return (
                <div className={styles.imgWrapper}>
                    <div className={styles.stretchLayer} style={{ backgroundImage: `url(${p_.src})` }} />
                </div>
            )
        }
    }
}

class EditorItem extends EditorItemLocalMethods {
    render() {
        const s_ = this.state
        const p_ = this.props

        const iconColor =
            p_.type === 'link' || p_.type === 'input' || p_.fileType === 'office' || p_.fileType === 'web_app'
                ? 'darkBlue'
                : 'darkCloud'

        return (
            <Draggable
                {...s_.position}
                zIndex={p_.zIndex}
                resizableZIndex={p_.zIndex}
                maxWidth={p_.maxWidth}
                maxHeight={p_.maxHeight}
                minWidth={p_.minWidth}
                minHeight={p_.minHeight}
                disableResize={p_.disableResize}
                disableDrag={p_.disableDrag}
                onSelect={p_.onSelect}
                onDragEnd={p_.onDragEnd}
                onResizeEnd={p_.onResizeEnd}
                onResize={this.onResize}
                selected={p_.selected}
                noBorder={p_.noBorder}
                borderColor={'selected'}
                selectedBorderColor={'white'}
                isShowDraggableSquares={p_.isScreenItem}
                selectedSquareColorType={p_.type === 'area' ? 'default' : 'contrast'}
            >
                <div
                    className={cn(styles.editorItemWrapper, p_.className)}
                    onMouseDown={p_.onMouseDown}
                    ref={(wrapper) => (this.wrapperRef = wrapper)}
                    style={{
                        ...p_.wrapperStyle,
                        animationPlayState: p_.playing ? 'running' : 'paused',
                        animationIterationCount: 'infinite',
                        animationFillMode: 'forwards',
                    }}
                >
                    {(() => {
                        switch (p_.fileType) {
                            case 'video':
                                return (
                                    <div
                                        className={styles.videoWrapper}
                                        onMouseOver={this.showVideoBar}
                                        onMouseLeave={this.hideVideoBar}
                                    >
                                        {(() => {
                                            const playing = p_.playing

                                            return (
                                                <div className={grid.full} style={p_.style}>
                                                    <div className={grid.full}>
                                                        <ReactPlayer
                                                            ref={(reactPlayer) => {
                                                                if (reactPlayer) {
                                                                    if (p_.seekTo) {
                                                                        const currentTime = Math.round(
                                                                            (p_.time - p_.startTime) / 1000
                                                                        )
                                                                        reactPlayer.seekTo(currentTime)
                                                                    }
                                                                }
                                                            }}
                                                            className={
                                                                p_.fillMode === 'stretch'
                                                                    ? 'editor-video-player stretched-video'
                                                                    : 'editor-video-player'
                                                            }
                                                            width="100%"
                                                            height="100%"
                                                            url={p_.src}
                                                            playing={playing}
                                                            onEnded={this.onReactPlayerEnded}
                                                            onProgress={this.onReactPlayerProgress}
                                                            onReady={this.onReactPlayerReady}
                                                            onError={this.onReactPlayerError}
                                                            progressInterval={250}
                                                            volume={s_.volume / 100}
                                                        />
                                                        <PreviewMediaMessage
                                                            error={s_.error}
                                                            src={p_.src}
                                                            style={{ top: 0 }}
                                                        />
                                                    </div>
                                                </div>
                                            )
                                        })()}
                                        <div className={styles.opacityLayer} />
                                        <div
                                            className={cn(
                                                styles.videoButtons,
                                                s_.isShowVideoBar ? styles.videoButtonsShow : ''
                                            )}
                                        >
                                            <div className={styles.progressWrapper}>
                                                <div
                                                    style={{ width: `${s_.played * 100}%` }}
                                                    className={styles.progress}
                                                />
                                            </div>
                                            <DropMenu
                                                active={s_.active}
                                                onChange={(active) => this.setState({ active })}
                                                onClick={this.clickDropMenu}
                                                className={item.blackOpacity}
                                                mod="centered"
                                                items={[
                                                    {
                                                        id: 'volume',
                                                        icon: 'volume_min',
                                                        tooltip: {
                                                            title: translate('volume'),
                                                        },
                                                        children: (
                                                            <RangeVolume
                                                                volume={s_.volume}
                                                                onChange={(volume) => this.setState({ volume })}
                                                            />
                                                        ),
                                                    },
                                                ]}
                                            />
                                        </div>
                                    </div>
                                )
                            case 'audio':
                                return (
                                    <div
                                        className={styles.videoWrapper}
                                        onMouseOver={this.showVideoBar}
                                        onMouseLeave={this.hideVideoBar}
                                    >
                                        {(() => {
                                            const playing = p_.playing

                                            return (
                                                <div className={grid.full}>
                                                    <div className={item.none}>
                                                        <ReactPlayer
                                                            ref={(reactPlayer) => {
                                                                if (reactPlayer) {
                                                                    if (p_.seekTo) {
                                                                        const currentTime = Math.round(
                                                                            (p_.time - p_.startTime) / 1000
                                                                        )
                                                                        reactPlayer.seekTo(currentTime)
                                                                    }
                                                                }
                                                            }}
                                                            width="0"
                                                            height="0"
                                                            url={p_.src}
                                                            playing={playing}
                                                            onEnded={this.onReactPlayerEnded}
                                                            onProgress={this.onReactPlayerProgress}
                                                            onReady={this.onReactPlayerReady}
                                                            onError={this.onReactPlayerError}
                                                            progressInterval={250}
                                                            volume={s_.volume / 100}
                                                        />
                                                    </div>
                                                    <PreviewMediaMessage
                                                        error={s_.error}
                                                        src={p_.src}
                                                        style={{ top: 0 }}
                                                    />
                                                </div>
                                            )
                                        })()}
                                        <div
                                            className={cn(styles.opacityLayer, item.contain)}
                                            style={{
                                                backgroundImage: `url(${filesHelpers.getSrc(p_)})`,
                                                backgroundSize: 'auto auto',
                                            }}
                                        />
                                        <div
                                            className={cn(
                                                styles.videoButtons,
                                                s_.isShowVideoBar ? styles.videoButtonsShow : ''
                                            )}
                                        >
                                            <div className={styles.progressWrapper}>
                                                <div
                                                    style={{ width: `${s_.played * 100}%` }}
                                                    className={styles.progress}
                                                />
                                            </div>
                                            <DropMenu
                                                active={s_.active}
                                                onChange={(active) => this.setState({ active })}
                                                onClick={this.clickDropMenu}
                                                className={item.blackOpacity}
                                                mod="centered"
                                                items={[
                                                    {
                                                        id: 'volume',
                                                        icon: 'volume_min',
                                                        tooltip: {
                                                            title: translate('volume'),
                                                        },
                                                        children: (
                                                            <RangeVolume
                                                                volume={s_.volume}
                                                                onChange={(volume) => this.setState({ volume })}
                                                            />
                                                        ),
                                                    },
                                                ]}
                                            />
                                        </div>
                                    </div>
                                )
                            case 'office':
                                return (
                                    <div className={styles.inputFileWrapper}>
                                        <div className={cn(grid.w40)} style={p_.style}>
                                            <Icon size={'100%'} type={filesHelpers.getFileIconName(p_)} />
                                        </div>
                                    </div>
                                )
                            case 'smartFolder':
                                return (
                                    <div className={styles.inputFileWrapper}>
                                        <div className={cn(grid.w40)} style={p_.style}>
                                            <Icon size={'100%'} type={filesHelpers.getFileIconName(p_)} />
                                        </div>
                                    </div>
                                )
                            case 'web_app':
                                return (
                                    <div className={cn(item.rel, grid.full)} style={p_.style}>
                                        <PreviewWebApp
                                            item={{ id: p_.id }}
                                            indents={'none'}
                                            {...getWebAppSizes(s_, p_)}
                                        />

                                        <div className={cn(item.abs, item.fullAbs)} />
                                    </div>
                                )
                            default:
                                if (
                                    this.textFileTypes.includes(p_.fileType) &&
                                    p_.data &&
                                    p_.data.displayAs === TEXT_DISPLAY_AS.QR_CODE
                                ) {
                                    return (
                                        <div className={grid.full}>
                                            <Preview fillMode={p_.fillMode} src={p_.thumbnail} />
                                        </div>
                                    )
                                }
                                if (p_.type === 'link') {
                                    return (
                                        <div className={styles.link} style={p_.style}>
                                            {!p_.additionalData.iFrameAvailable && (
                                                <div className={styles.linkInner}>
                                                    <div className={styles.linkDomain}>{s_.name}</div>
                                                    <div className={grid.w30}>
                                                        <img src={'images/editor/link.png'} alt="" />
                                                    </div>
                                                    <div>{p_.name}</div>
                                                </div>
                                            )}
                                            {p_.additionalData.iFrameAvailable && (
                                                <iframe
                                                    src={p_.name}
                                                    width="100%"
                                                    height="100%"
                                                    title={p_.name}
                                                    scrolling={getScrollInfo(p_)}
                                                />
                                            )}
                                            {p_.additionalData.iFrameAvailable && (
                                                <div className={cn(item.abs, item.fullAbs)} />
                                            )}
                                        </div>
                                    )
                                } else if (p_.type === 'text' || p_.type === 'xml') {
                                    if (this.textFileTypes.includes(p_.fileType)) {
                                        return (
                                            <div
                                                className={styles.text}
                                                style={p_.data ? filesHelpers.convertStyles(p_.data.style) : {}}
                                            >
                                                <span
                                                    ref={(textContentRef) => (this.textContentRef = textContentRef)}
                                                    style={{
                                                        ...this.getTextContentStyles(p_.name),
                                                        zoom: p_.type === 'text' ? p_.scale * p_.area.width : 1,
                                                    }}
                                                >
                                                    {helpers.strip_html_tags(p_.name)}
                                                </span>
                                            </div>
                                        )
                                    } else {
                                        return (
                                            <div className={styles.inputFileWrapper}>
                                                <div className={cn(grid.w40)}>
                                                    <Icon size={'100%'} type={filesHelpers.getFileIconName(p_)} />
                                                </div>
                                            </div>
                                        )
                                    }
                                } else if (p_.type === 'area') {
                                    return p_.children
                                } else if (p_.type === 'table') {
                                    return (
                                        <TableEditorPreview
                                            tableFormat={p_.data.tableFormat}
                                            cells={p_.data.cells}
                                            wrapperClassName={cn(styles.tablePreview)}
                                            scale={p_.scale}
                                        />
                                    )
                                } else if (p_.type === 'input') {
                                    return (
                                        <div className={styles.inputFileWrapper}>
                                            <div className={cn(grid.w40)}>
                                                <Icon size={'100%'} type={filesHelpers.getFileIconName(p_)} />
                                            </div>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <div className={grid.full} style={p_.style}>
                                            <Preview
                                                selectedPage={p_.selectedPage}
                                                selectedArea={p_.selectedArea}
                                                contentIndex={p_.contentIndex}
                                                areaIndex={p_.areaIndex}
                                                fillMode={p_.fillMode}
                                                src={p_.src}
                                                pictogramName={p_.data.pictogramName}
                                                isNewSvg={p_.data.isNewSvg}
                                                style={p_.data.style}
                                                body={p_.data.body}
                                                isActive={p_.selected && p_.selectedContentIndex === p_.contentIndex}
                                            />
                                        </div>
                                    )
                                }
                        }
                    })()}
                    {p_.showDeleteIcon && (
                        <div className={styles.delete} onClick={p_.onDelete}>
                            <Icon type={'delete'} color={'white'} size={15} />
                        </div>
                    )}
                    {!p_.playing && p_.showLayersIcon && (
                        <div className={styles.layers}>
                            <div className={styles.layersCount}>{p_.layersCount}</div>
                            <Icon tooltip={{ title: translate('layers') }} type={'layers'} color={'white'} size={15} />
                        </div>
                    )}
                </div>
            </Draggable>
        )
    }
}

EditorItem.propTypes = {
    name: PropTypes.string,
    type: PropTypes.string,
    isScreenItem: PropTypes.bool,
    src: PropTypes.string,
    style: PropTypes.object,
    width: PropTypes.number,
    height: PropTypes.number,
    left: PropTypes.number,
    top: PropTypes.number,
    fileType: PropTypes.string,
    selected: PropTypes.bool,
    disableResize: PropTypes.bool,
    disableDrag: PropTypes.bool,
    zIndex: PropTypes.number,
    minWidth: PropTypes.number,
    minHeight: PropTypes.number,
    maxWidth: PropTypes.number,
    maxHeight: PropTypes.number,
    showDeleteIcon: PropTypes.bool,
    showLayersIcon: PropTypes.bool,
    noBorder: PropTypes.bool,
    layersCount: PropTypes.number,
    scale: PropTypes.number,
    onSelect: PropTypes.func,
    onDelete: PropTypes.func,
    onDragEnd: PropTypes.func,
    onResizeEnd: PropTypes.func,
    onResize: PropTypes.func,
    fillMode: PropTypes.string,
    additionalData: PropTypes.object,
}

EditorItem.defaultProps = {
    additionalData: {},
    scale: 1,
    onResize: () => {},
    isScreenItem: false,
}

export default EditorItem
